import {AddEmployeeApp} from "../Funtionality/AddEmployeeApp";
import React from "react";
import {IconChipMultiplePerson, IconDocumentLinedGrid} from "../../../../components/buttons/IconButtons";
import CustomAvailableItems from "../../../../components/CustomAvailableAssignedItems/CustomAvailableItems";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";


/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 04 de 2026
 */

/**
 * Component used to manage available employees
 * or departments assignment for devices.
 *
 * This component handles:
 * - Search integration.
 * - Pagination integration.
 * - Dynamic assignment configuration.
 * - Available items rendering.
 * - Selected items rendering.
 * - Employee and department assignment flow.
 *
 * @component AddEmployee
 *
 * @param {Object} props - Component properties.
 * @param {Function} props.setBodyForExport - Updates export request body.
 * @param {Object|null} props.results - Search results data.
 * @param {Function} props.setResults - Updates search results.
 * @param {string} props.searchElement - Current search value.
 * @param {Function} props.setSearchElement - Updates search value.
 * @param {Function} props.setSearch - Updates advanced search state.
 * @param {Function} props.setSimpleSearch - Updates simple search state.
 * @param {boolean} props.modified - Indicates whether data was modified.
 * @param {Function} props.setModified - Updates modified state.
 * @param {Array<Object>} props.selected - Selected items.
 * @param {Function} props.setSelected - Updates selected items.
 * @param {number|string|undefined} props.id - Device identifier.
 * @param {string} props.authentication - Authentication mode identifier.
 * @param {string} props.subView - Current active tab/subview.
 * @param {Function} props.setDeviceListCustomAccessOrDepartment - Updates assigned resources list.
 *
 * @returns {JSX.Element} Add employee/department component.
 */
const AddEmployee  = (props) => {
    const {
        setBodyForExport,
        results,
        setResults,
        searchElement,
        setSearchElement,
        setSearch,
        setSimpleSearch,
        modified,
        setModified,
        selected,
        setSelected,
        id,
        authentication,
        subView,
        setDeviceListCustomAccessOrDepartment
    } = props;

    const {
        dynamicConfig
    } = AddEmployeeApp({
            selected,
            subView,
            setDeviceListCustomAccessOrDepartment,
            id
        });


    return (
        <CustomAvailableItems
            setBodyForExport={setBodyForExport}
            results={results}
            setResults={setResults}
            searchElement={searchElement}
            setSearchElement={setSearchElement}
            setSearch={setSearch}
            setSimpleSearch={setSimpleSearch}
            modified={modified}
            setModified={setModified}
            selected={selected}
            setSelected={setSelected}
            tableIconTitle={<IconDocumentLinedGrid height={16} width={16} className={"mr-8px mb-1 icon-color-general-950"}/>}
            selectedSectionIconTitle={<IconChipMultiplePerson height={18} width={18} className={"mr-8px mb-1 icon-color-general-950"}/>}
            labelRowsPerPage={dynamicConfig.labelRowsPerPage}
            tableNotInformationLegend={dynamicConfig.tableNotInformationLegend}
            selectedSectionNotInformationLegend={'no_items_added_yet'}
            tableBuildBody={({ page, rowsPerPage, searchElement }) => {
                const c = SEARCH_MODEL.setObject({
                    page,
                    size: rowsPerPage,
                    key: searchElement,
                    model: dynamicConfig.model,
                    userTypeIds: dynamicConfig.userTypeIds
                });
                if (!id) {
                    return {
                        body: c
                    };
                }

                if (!authentication) {
                    return null;
                }
                return {
                    ...c,
                    resourceId: id,
                    resourceString: authentication
                };
            }}
            tableEndPoint={dynamicConfig.api}
            keyId={dynamicConfig.keyId}
            viewTypeName={VIEW_TYPE.GRID.name}

            titleContainer={dynamicConfig.titleContainer}
            selectedSectionTitle={dynamicConfig.selectedSectionTitle}
            searchTitle={dynamicConfig.searchTitle}

            renderAvailableItem={dynamicConfig.renderAvailableItem}
            renderSelectedItems={dynamicConfig.renderSelectedItems}

        />
    );

}

export default AddEmployee
